import toNumber from 'lodash/toNumber';
import * as R from 'ramda';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import * as ValidateFns from './validate-fns';
import {createValidator} from './validators';

export const required = createValidator(
  ValidateFns.required,
  <FormattedMessage id="validation_errors.common.required" />
);

export const charsOnly = createValidator(
  ValidateFns.charsOnly,
  <FormattedMessage id="validation_errors.common.chars_only" />
);

export const houseNumber = createValidator(
  ValidateFns.houseNumber,
  <FormattedMessage id="validation_errors.common.house_number"/>,
);

export const notIntegerValidator = (numsCount:number) => createValidator(
  ValidateFns.notIntegerValidator(numsCount),
  <FormattedMessage id="validation_errors.common.not_numbers" />
);

export const notSymbolsValidator = (symbols: any[]) => createValidator(
  ValidateFns.notSymbolsValidator(symbols),
  <FormattedMessage id="validation_errors.common.not_symbols" />
);

export const number = createValidator(
  R.compose(ValidateFns.number, toNumber),
  <FormattedMessage id="validation_errors.common.number" />
);

export const integer = createValidator(
  ValidateFns.integer,
  <FormattedMessage id="validation_errors.common.integer" />
);

export const numberMinValue = (value: number, message?: string) =>
  createValidator(
    ValidateFns.minValue(value),
    <FormattedMessage
      id={message || "validation_errors.common.min_value"}
      values={{value}}
    />
  );
export const numberMaxValue = (value: number, message?: string) =>
  createValidator(
    ValidateFns.maxValue(value),
    <FormattedMessage
      id={message || "validation_errors.common.max_value"}
      values={{value}}
    />
  );

export const autocompleteRequired = createValidator(
  ValidateFns.autocompleteRequired,
  <FormattedMessage id="validation_errors.common.autocomplete_required" />
);

export const autocompleteRequiredLegacy = createValidator(
  ValidateFns.autocompleteRequiredLegacy,
  <FormattedMessage id="validation_errors.common.autocomplete_required" />
);

export const phone = createValidator(
  ValidateFns.phone,
  <FormattedMessage id="validation_errors.phone.not_valid" />
);

export const minLength = (length: number) =>
  createValidator(
    ValidateFns.minLength(length),
    <FormattedMessage
      id="validation_errors.common.min_length"
      values={{length}}
    />
  );

export const maxLength = (length: number) =>
  createValidator(
    ValidateFns.maxLength(length),
    <FormattedMessage
      id="validation_errors.common.max_length"
      values={{length}}
    />
  );

export const maxItems = (count: number) =>
  createValidator(
    ValidateFns.maxItems(count),
    <FormattedMessage
      id="validation_errors.common.max_items"
      values={{count}}
    />
  );
export const userInn = createValidator(
  ValidateFns.inn,
  <FormattedMessage id="validation_errors.inn.not_valid" />
);

export const email = createValidator(
  ValidateFns.email,
  <FormattedMessage id="validation_errors.email.not_valid" />
);

export const url = createValidator(
  ValidateFns.url,
  <FormattedMessage id="validation_errors.url.not_valid" />
);

export const youtube = createValidator(
  ValidateFns.youtube,
  <FormattedMessage id="validation_errors.youtube.not_valid" />
);
export const youtubeProfile = createValidator(
  ValidateFns.youtubeProfile,
  <FormattedMessage id="validation_errors.youtube.not_valid" />
);

export const videoLink = createValidator(
  ValidateFns.videoLink,
  <FormattedMessage id="validation_errors.videoLink.not_valid" />
);

export const tiktok = createValidator(
    ValidateFns.tiktok,
    <FormattedMessage id="validation_errors.tiktok.not_valid" />
);
export const tiktokCommon = createValidator(
    ValidateFns.commonTiktok,
    <FormattedMessage id="validation_errors.tiktok.not_valid" />
);

export const instagram = createValidator(
  ValidateFns.instagram,
  <FormattedMessage id="validation_errors.instagram.not_valid" />
);

export const facebook = createValidator(
  ValidateFns.facebook,
  <FormattedMessage id="validation_errors.facebook.not_valid" />
);


export const cadastralNumber = createValidator(
  ValidateFns.cadastralNumber,
  <FormattedMessage id="validation_errors.cadastral_number.not_valid" />
);

export const noValidation = (_: any) => undefined;

export const personalPhoto = createValidator(
  ValidateFns.personalPhoto,
  <FormattedMessage id="validation_errors.personal_photo.no_person" />
);

export const textHasUrl = createValidator(
  ValidateFns.textHasUrl,
  <FormattedMessage id="validation_errors.about.has_url" />
);

export const textHasPhone = createValidator(
  ValidateFns.textHasPhone,
  <FormattedMessage id="validation_errors.about.has_phone" />
);

export const isPointWithinCityContour = (geojson: any) =>
  createValidator(
    ValidateFns.isWithinContour(geojson),
    <FormattedMessage id="validation_errors.offer_position.not_within_the_selected_city" />
  );
export const isPointWithinDistrictContour = (geojson: any) =>
    createValidator(
        ValidateFns.isWithinContour(geojson),
        <FormattedMessage id="validation_errors.offer_position.not_within_the_selected_district" />
    );

export const isPointWithinResidentialContour = (geojson: any) =>
  createValidator(
    ValidateFns.isWithinContour(geojson),
    <FormattedMessage
      id="validation_errors.offer_position.not_within_the_selected_residential"
    />,
  );

export const isPointWithinAreaPolygonContour = (geojson: any) =>
  createValidator(
    ValidateFns.isWithinContour(geojson),
    <FormattedMessage id="validation_errors.offer_position.not_within_the_selected_area_polygon" />
  );

export const noopValidator = (_: any) => undefined;
